// eslint-disable
import React, { useCallback, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Api from "./Api";
import PARSE from "html-react-parser";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import store from "../../context/store";
import { Helmet } from "react-helmet";

const api = new Api();

export default function TBS_Hero() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [background, setBackground] = useState("");
  const [backgroundSmall, setBackgroundSmall] = useState("");
  const [boxContent, setBoxContent] = useState(null);

  const [listButton, setListButton] = useState(null);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setBackground(
                section?.widget_contents[0]?.file ||
                  section?.widget_contents[0]?.file
              );
              console.log(
                "🚀 ~ file: SSoft_Hero.jsx:51 ~ sec.forEach ~ section?.widget_contents[0]:",
                section?.widget_contents[0]
              );
              setBackgroundSmall(
                section?.widget_contents[0]?.asset_mobile ||
                  section?.widget_contents[0]?.file
              );
              break;
            }
            case 1: {
              setBoxContent(section?.widget_contents[0]);
              break;
            }
            case 2: {
              setListButton(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++; // Increment the switch case completion counter
        });

        if (switchCaseCompleted === 3) {
          setLoaded(true); // Set loaded to true after all switch cases have completed
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <>
      <Helmet>
        {/* ==== BASIC SEO ==== */}
        <title>
          Services | PT Supersoft Sistemindo - Infor & Hexagon Implementation
          Partner Indonesia
        </title>
        <meta
          name="description"
          content="Temukan berbagai layanan profesional dari PT Supersoft Sistemindo — partner resmi Infor & Hexagon di Indonesia. Kami menyediakan layanan konsultasi, lisensi, implementasi, training, dan dukungan teknis untuk solusi enterprise seperti Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM."
        />
        <meta
          name="keywords"
          content="Infor implementation Indonesia, Hexagon EAM services, enterprise software Indonesia, Infor SunSystems support, PT Supersoft Sistemindo, konsultasi software ERP"
        />
        <link rel="canonical" href="https://ptsupersoft.com/services" />

        {/* ==== OPEN GRAPH ==== */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ptsupersoft.com/services" />
        <meta
          property="og:title"
          content="Services | PT Supersoft Sistemindo - Infor & Hexagon Implementation Partner Indonesia"
        />
        <meta
          property="og:description"
          content="Supersoft menyediakan layanan lisensi, implementasi, training, dan support untuk solusi Infor & Hexagon di Indonesia."
        />
        <meta
          property="og:image"
          content="https://bzpublishassets.blob.core.windows.net/media/assets/services_banner.png"
        />

        {/* ==== AI SEARCH OPTIMIZATION ==== */}
        <meta
          name="ai-keywords"
          content="Infor implementation Indonesia, Hexagon EAM services, enterprise software support Indonesia, Infor partner Indonesia, Supersoft Sistemindo"
        />
        <meta
          name="ai-summary"
          content="PT Supersoft Sistemindo menawarkan layanan konsultasi, lisensi, implementasi, training, dan dukungan untuk solusi Infor dan Hexagon di Indonesia."
        />

        {/* ==== FAQ SCHEMA ==== */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Layanan apa saja yang ditawarkan PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Kami menawarkan layanan lisensi software, implementasi sistem, pelatihan pengguna, integrasi data, dan dukungan teknis untuk solusi Infor dan Hexagon."
            }
          },
          {
            "@type": "Question",
            "name": "What services does PT Supersoft Sistemindo provide?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "PT Supersoft Sistemindo provides licensing, implementation, training, data integration, and technical support for Infor and Hexagon enterprise solutions."
            }
          },
          {
            "@type": "Question",
            "name": "Apakah Supersoft menyediakan dukungan setelah implementasi?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ya, kami menyediakan support dan maintenance berkelanjutan untuk memastikan sistem tetap berjalan optimal dan sesuai kebutuhan bisnis Anda."
            }
          }
        ]
      }
      `}</script>
      </Helmet>
      <div className="mt-[78px] s:!mb-0 mb-[250px] tall:mb-[250px] short:mb-[180px]">
        <div className=" qhd:h-[60vh] hd2xl:max-h-[1000px] hd2xl:h-[900px] hd3xl:h-[80vh] lg:max-h-[800px] md:max-h-[600px] md:h-[585px] s:h-[60vh] s:max-h-[500px]  max-h-[300px]  h-[75vh] ">
          {/* <img
          height="auto"
          width="auto"
          src={background}
          fetchpriority="high"
          alt={boxContent?.article_language?.title}
          className="absolute left-0 w-full qhd:h-[60vh] hd2xl:max-h-[1000px] hd2xl:h-[900px] hd3xl:h-[80vh] lg:max-h-[800px] md:max-h-[600px] md:h-[585px] s:h-[60vh] s:max-h-[500px]  max-h-[300px]  h-[75vh] object-cover object-top "
        /> */}
          <picture className="h-full w-full">
            <source
              media="(max-width: 576px)"
              srcSet={backgroundSmall}
              sizes="576px"
              height="auto"
              width="auto"
              src={background}
              fetchpriority="high"
              alt={boxContent?.article_language?.title}
              className="absolute left-0 w-full qhd:h-[60vh] hd2xl:max-h-[1000px] hd2xl:h-[900px] hd3xl:h-[80vh] lg:max-h-[800px] md:max-h-[600px] md:h-[585px] s:h-[60vh] s:max-h-[500px]  max-h-[300px]  h-[75vh] object-cover object-top "
            />
            <source srcSet={background} sizes="100vw" />
            <img
              height="auto"
              width="auto"
              src={background}
              fetchpriority="high"
              alt={boxContent?.article_language?.title}
              className="absolute left-0 w-full qhd:h-[60vh] hd2xl:max-h-[1000px] hd2xl:h-[900px] hd3xl:h-[80vh] lg:max-h-[800px] md:max-h-[600px] md:h-[585px] s:h-[60vh] s:max-h-[500px]  max-h-[300px]  h-[75vh] object-cover object-top "
            />
          </picture>
          <div className="absolute z-10 inset-0 top-[80px]  qhd:h-[60vh] hd2xl:max-h-[1000px] hd2xl:h-[900px] hd3xl:h-[80vh] lg:max-h-[800px] md:max-h-[600px] md:h-[585px] s:h-[60vh] s:max-h-[500px]  max-h-[300px]  h-[75vh] w-full ">
            <div className="section-container section-margin-x h-full w-full flex flex-col items-start justify-center s:relative absolute s:translate-x-0 s:left-0 s:-translate-x-0  left-1/2 -translate-x-1/2 s:!-bottom-0 -bottom-[220px] short:-bottom-[150px] tall:-bottom-[220px]  ">
              <div className="animate-in fade-in ease-in   bg-white fhdx:p-[80px] qhd:p-[55px] s:p-[45px] p-[25px] w-fit fhd:max-w-[800px] hd2xl:max-w-[700px] hd:max-w-[650px] mdl:max-w-[500px] md:max-w-[500px] s:max-w-[430px] max-w-[100vw] h-fit s:shadow-none shadow-xl">
                <h1 className="hd:prose-p:text-[55px] hd2xl:prose-p:text-[59px] qhd:prose-p:text-[67px] fhd:prose-p:text-[64px] mdl:prose-p:text-[42px] prose-p:text-[32px]  prose-p:leading-[115%] text-[#0D4052] font-dmsans-bold font-[700] max-wd-[500px]">
                  {PARSE(boxContent?.article_language?.content)}
                </h1>
                <h2 className="qhd:text-[29px] fhd:text-[26px] hd2xl:text-[22px] text-[18px] pt-[25px] leading-[115%] font-inter">
                  {boxContent?.article_language?.summary}
                </h2>
                <div className="pt-[30px] space-x-[15px]  flex flex-row ">
                  <Link
                    to={listButton[0]?.article_language?.path || "/"}
                    className=""
                    onClick={() =>
                      store.dispatch({
                        type: "topicStore/setTopicValue",
                        payload: "General",
                      })
                    }
                  >
                    <div className="qhd:text-[29px] fhd:text-[26px] hd2xl:text-[22px] s:text-[16px] text-[12px] flex items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px]  px-[18px]  bg-[#E12726] rounded-[8px] text-white s:w-fit font-semibold leading-[20px]">
                      {listButton[0]?.article_language.title}
                    </div>
                  </Link>

                  {listButton.length > 1 &&
                  listButton[1]?.assets[0]?.asset_file ? (
                    <Link
                      to={listButton[1]?.article_language?.path || "/"}
                      className=""
                    >
                      <div className="qhd:text-[29px] fhd:text-[26px] hd2xl:text-[22px] s:text-[16px] text-[12px] flex s:space-x-[16px] space-x-[6px] border items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px] text-center px-[18px]  text-[#0D4052] rounded-[8px] bg-white s:w-fit font-semibold leading-[20px]">
                        <img
                          src={listButton[1]?.assets[0]?.asset_file}
                          alt={listButton[1]?.assets[0]?.description}
                          className=""
                        />
                        <div className="">
                          {listButton[1]?.article_language.title}
                        </div>
                      </div>
                    </Link>
                  ) : (
                    listButton.length > 1 && (
                      <Link
                        to={listButton[1]?.article_language?.path || "/"}
                        className=""
                      >
                        <div className=" qhd:text-[29px] fhd:text-[26px] hd2xl:text-[22px] s:text-[16px] text-[12px] flex items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px] text-center px-[18px]  bg-[#0D4052] rounded-[8px] text-white s:w-fit font-semibold leading-[20px]">
                          {listButton[1]?.article_language.title}
                        </div>
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <Skeleton
      width={"100%"}
      className="!z-[100] qhd:!h-[calc(60vh+78px)] md:!h-[calc(585px+78px)] h-[calc(60vh+78px)]"
    />
  );
}
